import React from 'react';

export default function CmBadge({ color = 'default', children }) {
  return (
    <span className={`cm-badge cm-badge--${color}`}>
      {children}
    </span>
  );
}
